import { services } from '../../../../constants/services';
import { removeWithQueryParams } from '../../../../utils/api';

export class DeleteReservationsService {
	async run(params: any): Promise<void> {
		await removeWithQueryParams(`${services.booking}/deleteBooking`, params);
	}
}

